import {Link} from "react-router-dom";
import React, {Component} from 'react';
import logo from '../../assets/img/code_me_up_logo.png'

class Logo extends Component {
    render() {
        return (
            <div className="logo-area">
                <Link to="/">
                    <img src={logo} alt="cmu-logo"/>
                </Link>
            </div>
        );
    }
}

export default Logo;